import React from 'react';
import MarketingDetailPage from './MarketingDetailPage';
import { SMS_CONFIG } from '../constants/marketingSmsColumnsConfig';

function ReportingMarketingSmsPage({ team, csrfToken, currentUser, venueOwnerships }) {
  return (
    <MarketingDetailPage
      team={team}
      csrfToken={csrfToken}
      venueOwnerships={venueOwnerships}
      config={SMS_CONFIG}
    />
  );
}

export default ReportingMarketingSmsPage;
